import basicProfileInfoReducer from './basicProfileInfoReducer';
import layoutReducer from './layoutReducer';
import formReducer from './formReducer';

export default {
    basicInfo: basicProfileInfoReducer,
    layout: layoutReducer,
    form: formReducer,
};
